import { useParticipantDetails } from "../../../context/participantDetails";
import { useGetMyPrivilegesList } from "../../../components/myPrivileges/dataloader";
import ApiRegistrationFormForTicketUpgrade from "shared/types/ApiRegistrationFormForTicketUpgrade";
import React from "react";
import PrivilegeSource from "shared/enums/PrivilegeSource";
import { useOutletContext } from "react-router-dom";

export default function useApplicableFormsListService() {
  const { participantDetails } = useParticipantDetails();
  const { applicableFormsList } =
    useOutletContext<{ applicableFormsList: Array<ApiRegistrationFormForTicketUpgrade> }>();
  const { data: privilegesList } = useGetMyPrivilegesList(participantDetails?.registrationParticipantId, true);

  const currentTicketDetails: ApiRegistrationFormForTicketUpgrade = React.useMemo(() => {
    return {
      ...(participantDetails?.ticketDetails as ApiRegistrationFormForTicketUpgrade),
      accessPrivileges: privilegesList
    };
  }, [privilegesList, participantDetails?.ticketDetails]);

  const purchasedPrivilegesList = React.useMemo(() => {
    return privilegesList?.filter(item => item.privilegeSource?.includes(PrivilegeSource.INVENTORY)) ?? [];
  }, [privilegesList]);

  return {
    applicableFormsList,
    currentTicketDetails: currentTicketDetails,
    purchasedPrivilegesList
  };
}
